module.exports = __webpack_public_path__ + "static/img/tjzs.73492c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tjzs.png
// module id = gdLk
// module chunks = 1